export default {
  address: "address",
  bank_number: "bank_number",
  email: "email",
  dob: "dob",
  relation_number: "relation_number",
  id: "id",
  label: "label",
  name: "name",
  first_name: "first_name",
  postal_code: "postal_code",
  phone: "phone",
};
